/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { EmbersButton } from '../button/button';
import { EmbersCard } from '../card/card';
import { PROMETHEAN_PURPLE_GRAPE } from '../styles/colors/colors';
import { StyledBarCard, StyledInfoCard } from './templateStyles';
export var BarCard = function BarCard(_ref) {
  var title = _ref.title,
    titleInfo = _ref.titleInfo,
    content = _ref.content,
    image = _ref.image;
  return /*#__PURE__*/React.createElement(EmbersCard, {
    readonly: true,
    title: title,
    titleExtra: titleInfo,
    style: {
      borderLeft: "8px solid ".concat(PROMETHEAN_PURPLE_GRAPE)
    }
  }, /*#__PURE__*/React.createElement(StyledBarCard, {
    className: "BarCard-body"
  }, /*#__PURE__*/React.createElement("div", null, image), typeof content === 'string' ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    style: {
      paddingBottom: 16
    }
  }, content), /*#__PURE__*/React.createElement(EmbersButton, null, "Download")) : content));
};
export var InfoCard = function InfoCard(_ref2) {
  var title = _ref2.title,
    content = _ref2.content,
    buttonText = _ref2.buttonText,
    buttonType = _ref2.buttonType,
    image = _ref2.image;
  return /*#__PURE__*/React.createElement(EmbersCard, {
    readonly: true,
    title: title
  }, /*#__PURE__*/React.createElement(StyledInfoCard, {
    className: "InfoCard-body"
  }, /*#__PURE__*/React.createElement("div", null, image), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, content), buttonText && /*#__PURE__*/React.createElement(EmbersButton, {
    level: buttonType || 'secondary',
    drawingStyle: "outlined"
  }, buttonText))));
};